module.exports = __webpack_public_path__ + "static/media/7-_DSC6395.527a0577.jpg";